<template>
  <div class style="width: 1110px;margin: 0 auto;">
    <div class="fo_welcome">找回密码</div>
    <div style="margin-top: 60px;">
      <el-steps :active="isActive" align-center process-status="wait" class="el-title">
        <el-step title="账号验证">
          <i class="phone-icon-active" slot="icon"></i>
        </el-step>
        <el-step title="短信找回">
          <i
            class="message-icon"
            slot="icon"
            :class="isActive==1?'message-icon':'message-icon-active'"
          ></i>
        </el-step>
        <el-step title="密码重设">
          <i
            class="set-password"
            slot="icon"
            :class="(isActive==3 || isActive==4)?'set-password-active':'set-password'"
          ></i>
        </el-step>
        <el-step title="设置完成">
          <i class="ok-icon" slot="icon" :class="isActive==4?'ok-icon-active':'ok-icon'"></i>
        </el-step>
      </el-steps>
    </div>
    <div v-show="isActive==1">
      <div
        class
        style="margin: 0 auto;width: 890px;background: #F9F9F9;border: 1px solid #EAEAEA;padding:20px 30px;margin-bottom: 30px;"
      >
        <div class style="text-align: left;color: #333333;">▪ 请输入你需要找回登录密码的账户名（11位手机号）</div>
      </div>
      <div class style="max-width: 750px;margin: 0 auto 140px auto ;">
        <div class style="margin-left:180px;">
          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            class="demo-ruleForm1"
            label-position="left"
          >
            <el-form-item label="登录账户名" label-width="100px" prop="username" class="register-item">
              <el-col :span="14">
                <el-input
                  class="fo-input"
                  type="text"
                  v-model="ruleForm1.username"
                  autocomplete="off"
                  placeholder="请输入手机号码"
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
              <el-col :span="4"></el-col>
            </el-form-item>
            <el-form-item label="图片验证码" label-width="100px" prop="imageCode" class="register-item">
              <el-col :span="14">
                <el-input
                  class="fo-input"
                  type="text"
                  v-model="ruleForm1.imageCode"
                  autocomplete="off"
                  placeholder="请输入图片验证码"
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
              <el-col :span="5" style="padding-left:10px;">
                <Sidentify :identifyCode="identifyCode" style="line-height: normal;"></Sidentify>
              </el-col>
              <el-col :span="5" style="padding-left:30px;">
                <el-button type="text" style="color: #00418E;" @click="refreshCode">看不清，换一张</el-button>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="16">
                <el-button
                  class="fo-submit"
                  @click="submitUsername('ruleForm1')"
                  style="width: 100%;background-color: #1B1464;color:#fff;padding:20px 80px;"
                >提交</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-show="isActive==2">
      <div v-show="foMode == 1">
        <div
          class
          style="max-width: 890px;margin: 0 auto;font-size: 14px;padding: 20px 30px; background: #F9F9F9;border: 1px solid #EAEAEA;margin-bottom: 30px;"
        >
          <div
            class
            style="text-align: left;color: #333333;"
          >▪ 手机号验证码验证 账户"{{phones.phone}}"为确认是你本人操作，请完成以下验证</div>
          <!-- <div class style="text-align: left;color: #333333;">▪ 您正在为“手机号”找回密码，请完成短信验证</div> -->
        </div>

        <!-- <div class style="max-width: 400px;margin:0 auto 0px auto;">
          <el-form status-icon class="demo-ruleForm2 demo-ruleForm3" label-position="left">
            <el-form-item label="手机号码" label-width="100px">
              <el-col :span="7">{{phones.phone}}</el-col>
              <el-col :span="6">
                <div class="fg_change2">
                  <el-link
                    :underline="false"
                    @click="exchangeMark"
                    style="text-decoration:underline;"
                  >已换号？</el-link>
                </div>
              </el-col>
            </el-form-item>
          </el-form>
        </div>-->
        <div class style="max-width: 750px;margin:0 auto 200px auto;">
          <div style="margin-left:180px;">
            <el-form
              :model="ruleForm2"
              :rules="rules2"
              ref="ruleForm2"
              class="demo-ruleForm2"
              label-position="left"
            >
              <el-form-item
                label="短信验证码"
                label-width="100px"
                prop="messageCode"
                class="register-item"
              >
                <el-col :span="14">
                  <el-input class="fo-input" v-model="ruleForm2.messageCode" placeholder="请输入短信验证码"></el-input>
                  <span class="register-require">*</span>
                </el-col>
                <el-col :span="8">
                  <button
                    type="text"
                    class="message-btn"
                    @click.prevent="getMessageCode('ruleForm1')"
                    v-text="messageBtn"
                    :disabled="timer>0"
                  >0</button>
                </el-col>
              </el-form-item>
              <el-form-item>
                <el-col :span="16" style="width: 375px;">
                  <el-button
                    class="fo-submit"
                    @click="submitMessage('ruleForm2')"
                    style="width: 100%;background-color: #1B1464;color:#fff;padding:20px 80px;"
                  >提交</el-button>
                </el-col>
              </el-form-item>
              <!-- <div class="fg_change3">
              <el-link :underline="false" @click="cellphoneVerify3">更换其他验证方式</el-link>
              </div>-->
            </el-form>
          </div>
        </div>
      </div>
      <div v-show="foMode == 2" class="foMode2">
        <div class="foMode2_zl">
          <div
            style="margin: 0 auto;width: 890px;background: #F9F9F9;border: 1px solid #EAEAEA;padding-top: 20px;padding-bottom: 20px;"
          >
            <div>▪ 请认真填写下面的资料，为了保障您的账号安全，只有当您提供的资料足够完整且真实时，才能通过身份验证。</div>
            <div>▪ 申诉结果会在3个法定工作日内以邮件形式发送到您填写的"联系邮箱"，请注意查收。</div>
          </div>
        </div>
        <div style="width: 390px;margin: 0 auto;padding-top: 20px;">
          <el-form
            status-icon
            label-width="100px"
            :model="mailForm"
            :rules="rules"
            ref="mailForm"
            class="demo-ruleForm fgp_identity"
          >
            <el-form-item label="姓名" prop="name">
              <el-input v-model="mailForm.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="公司" prop="company">
              <el-input v-model="mailForm.company" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="identity">
              <el-input v-model="mailForm.identity"></el-input>
            </el-form-item>
            <el-form-item label="联系手机" prop="cellphone">
              <el-input v-model="mailForm.cellphone"></el-input>
              <div class="cellphone_annotation">请填写正在使用的手机号码，申诉成功后，该手机将绑定到你的帐号上，后续可以使用此手机号进行重设密码</div>
            </el-form-item>
            <el-form-item label="联系邮箱" prop="mailbox">
              <el-input v-model="mailForm.mailbox"></el-input>
              <div class="cellphone_annotation">请填写正在使用的邮箱，申诉成功后，申诉结果将会发送到此邮箱中</div>
            </el-form-item>
            <el-form-item prop="check">
              <div class="choice_box">
                <el-checkbox class="choice" v-model="mailForm.check">
                  <div
                    class="cellphone_annotation2"
                  >我承诺所有申诉表单上提供的信息真实、准确，如发现虚假、欺诈行为，将承担一切因此引起的后果，青岛怡之航物流有限公司将保留提交司法机关，追究法律责任的权利。</div>
                </el-checkbox>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="submit_mailbox" @click="submitMailbox">提交</el-button>
            </el-form-item>
            <div class="fg_change">
              <el-link :underline="false" @click="cellphoneVerify3">更换其他验证方式</el-link>
            </div>
          </el-form>
          <div style="height: 60px;"></div>
        </div>
      </div>
      <div v-show="foMode == 3" class="foMode2">
        <div
          style="height: 90px;margin: 0 auto;line-height: 61px;background: #F9F9F9;border: 1px solid #EAEAEA;width: 890px;"
        >
          <div class="foMode2_zl2">▪ 请选择您想要的验证方式</div>
        </div>
        <div class="select_verify_cellphone_box">
          <el-row>
            <el-col :span="1" style="padding-l" class="select_verify_cellphone_item1">
              <img class="fgp_picture1" src="../assets/img/phone.png" alt />
            </el-col>
            <el-col :span="8" class="select_verify_cellphone_item2">
              <div class="select_verify_cellphone">
                <div class="select_verify_cellphone1">手机短信验证</div>
                <div class="select_verify_cellphone2">您需要用密保手机进行短信验证</div>
              </div>
            </el-col>
            <el-col :span="8" class="select_verify_cellphone_item3">
              <div class="grid-content bg-purple">
                <el-button class="select_verify_cellphone_butt" @click="cellphoneVerify">立即验证</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="select_verify_cellphone_box2">
          <el-row>
            <el-col :span="1" style="padding-l" class="select_verify_cellphone_item1">
              <!-- <div class="grid-content bg-purple">我是手机</div> -->
              <img class="fgp_picture2" src="../assets/img/put-box-active.png" alt />
            </el-col>
            <el-col :span="8" class="select_verify_cellphone_item2">
              <div class="select_verify_cellphone">
                <div class="select_verify_cellphone1">以上无法使用</div>
                <div class="select_verify_cellphone2">您需要填写真实、详尽的账号资料提交给到客服进行人工申诉，申诉将在3个工作日内完成</div>
              </div>
            </el-col>
            <el-col :span="8" class="select_verify_cellphone_item3">
              <div class="grid-content bg-purple">
                <el-button class="select_verify_cellphone_butt" @click="cellphoneVerify2">立即验证</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div v-show="isActive==3">
      <div
        class
        style="max-width: 890px;margin: 0 auto;font-size: 14px;padding: 20px 30px;background: #F9F9F9;border: 1px solid #EAEAEA;margin-bottom: 30px;"
      >
        <div class style="text-align: left;color: #333333;">▪ 您正在为会员登录名“手机号”设置新密码，请确保两次密码输入一致。</div>
      </div>
      <div class style="max-width: 750px;margin: 0 auto 140px auto;">
        <div style="margin-left:180px;">
          <el-form
            :model="ruleForm3"
            label-position="left"
            :rules="rules3"
            ref="ruleForm3"
            class="demo-ruleForm2"
          >
            <el-form-item label="新登录密码" label-width="100px" prop="newPasswd" class="register-item">
              <el-col :span="14">
                <el-input
                  class="fo-input"
                  type="password"
                  v-model="ruleForm3.newPasswd"
                  autocomplete="off"
                  placeholder="请输入新登录密码"
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
            </el-form-item>
            <el-form-item label="确认密码" label-width="100px" prop="checkPasswd" class="register-item">
              <el-col :span="14">
                <el-input
                  class="fo-input"
                  type="password"
                  v-model="ruleForm3.checkPasswd"
                  autocomplete="off"
                  placeholder="请输入确认密码"
                ></el-input>
                <span class="register-require">*</span>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :span="24" style="width: 375px;">
                <el-button
                  class="fo-submit"
                  @click="submitSetPassword('ruleForm3')"
                  style="width: 100%;background-color: #1B1464;color:#fff;padding:20px 80px;"
                >提交</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div v-show="isActive==4">
      <div class style="max-width: 950px;margin: 0 auto;font-size: 14px;padding: 40px 0;">
        <div
          style="max-width: 950px;margin: 0 auto;font-size: 14px;padding: 20px 0;background: #F9F9F9;border: 1px solid #EAEAEA;margin-bottom: 20px;"
        >
          <div
            style="text-align: left;color: #333333;padding-left:45px;"
          >▪ 您已完成会员登录名“手机号”的密码重设，请使用新密码登录并体验中航运捷运的服务</div>
        </div>

        <div class style="margin:40px 0 300px 0">
          <el-col :span="24">
            <el-button
              class="fo-submit"
              style="background: #1B1464;color:#fff;padding:21px 135px;"
              @click="nowLogin()"
            >立即登录</el-button>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidentify from "../components/Sidentify.vue";
export default {
  components: { Sidentify },
  data() {
    //手机号正则
    var validateCellphone = (rule, value, callback) => {
      var regPassword = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!regPassword.test(value)) {
        callback(new Error("请输入正确格式的手机号"));
      } else {
        callback();
      }
    };
    //手机号码验证
    var validatePhone = (rule, value, callback) => {
      var that = this;
      var regPhone = /^1[3456789]\d{9}$/; //手机号校验正则
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!regPhone.test(value)) {
        callback(new Error("手机号码格式有误，请输入正确的手机号码"));
      } else {
        let params = {};
        params.userAccountName = that.ruleForm1.username;
        let response = that.apiService
          .get("/sinoslog-ops-service/user/mobilePhone", { params })
          .then(res => {
            if (res.data.data.data == "未注册") {
              callback(new Error("手机号码不存在"));
            } else {
              callback();
            }
          });
      }
    };
    //图片验证码
    var validateImageCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入图片验证码"));
      } else if (
        value.toLocaleLowerCase() != this.identifyCode.toLocaleLowerCase()
      ) {
        callback(new Error("输入的图片验证码错误"));
      } else {
        callback();
      }
    };
    //短信验证码
    var checkMessageCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("短信验证码为空"));
      } else if (value.toString().length !== 6) {
        callback(new Error("请输入长度为4位验证码"));
      } else {
        callback();
      }
    };
    //设置密码
    var validatePasswd = (rule, value, callback) => {
      var regPassword = /^.*(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])\w{5,30}/;
      if (!value) {
        callback(new Error("请输入新登录密码"));
      } else if (!regPassword.test(value)) {
        callback(new Error("密码必须包含6到30位大小写字母、数字"));
      } else {
        callback();
      }
    };
    //校验密码
    var validateCheckPasswd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm3.newPasswd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      phones: {
        phone: ""
      },
      foMode: 1, //身份验证显示页面
      isActive: 1, //默认显示验证手机步骤
      messageBtn: "发送短信验证码",
      timer: 0, //设置定时器初始值为0
      mailForm: {
        //其它验证方式数据
        name: "", //姓名
        company: "", //公司
        identity: "", //身份证
        cellphone: "", //手机号
        mailbox: "", //邮箱
        check: [] //勾选
      },
      identifyCodes:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "", //图片验证码
      ruleForm1: {
        username: "", //登录账号名
        imageCode: "" //图片验证码
      },
      ruleForm2: {
        messageCode: "" //短信验证码
      },
      ruleForm3: {
        newPasswd: "", //新登录密码
        checkPasswd: "" //确认密码
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司", trigger: "blur" }],
        identity: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: "证件号码格式有误！",
            trigger: "blur"
          }
        ],
        cellphone: [
          { required: true, validator: validateCellphone, trigger: "blur" }
        ],
        mailbox: [
          { required: true, message: "请输入邮箱号", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱号", trigger: "blur" }
        ],
        check: [
          {
            type: "array",
            required: true,
            message: "请阅读后同意勾选",
            trigger: "change"
          }
        ]
      },
      rules1: {
        username: [{ validator: validatePhone, trigger: "blur" }],
        imageCode: [{ validator: validateImageCode, trigger: "blur" }]
      },
      rules2: {
        messageCode: [{ validator: checkMessageCode, trigger: "blur" }]
      },
      rules3: {
        newPasswd: [{ validator: validatePasswd, trigger: "blur" }],
        checkPasswd: [{ validator: validateCheckPasswd, trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4); //初始化生成图片验证码
  },
  methods: {
    //显示截取手机号
    ooloo() {
      let mobilePhones = this.ruleForm1.username;
      var wwesfdf = mobilePhones
        .match(/(\d{3})(\d{5})(\d{3})/)
        .slice(1)
        .reduce(function(value, item, index) {
          return index === 1 ? value + "*****" : value + item;
        });
      this.phones.phone = wwesfdf;
    },
    //账户验证提交
    submitUsername(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          that.isActive = 2;
          this.ooloo();
        } else {
          return false;
        }
      });
    },
    //短信验证提交
    submitMessage(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          let params = {};
          params.mobilePhone = that.ruleForm1.phone;
          params.smsCode = that.ruleForm1.messageCode;
          let response = that.apiService
            .get("/sinoslog-ops-service/sendMessage/checkSmsCode", { params })
            .then(res => {
              if (res.data.data.code == "failed") {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "验证码已失效",
                  type: "error",
                  offset: 300
                });
              } else if (res.data.data.code == "error") {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "验证码不一致",
                  type: "error",
                  offset: 300
                });
              } else {
                that.isActive = 3;
              }
            });
        } else {
          return false;
        }
      });
    },
    //密码重设
    submitSetPassword(formName) {
      var that = this;
      that.$refs[formName].validate(valid => {
        if (valid) {
          that
            .axios({
              method: "post",
              url: that.apiUrl + "/bnwl_user_business/sysUser/forgetPwd",
              timeout: 60000,
              responseType: "json",
              data: {
                userName: that.ruleForm1.username,
                newPwd: that.ruleForm3.newPasswd
              }
            })
            .then(function(response) {
              if (response.data.msg == "OKPY") {
                that.isActive = 4;
              } else {
                that.$message({
                  showClose: true,
                  customClass: "register-bg",
                  message: "密码设置失败",
                  type: "error",
                  offset: 300
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    //获取短信验证码
    getMessageCode() {
      var that = this;
      that.timer = 60; //设定重新获取验证码为60秒
      var setInterObj = setInterval(function() {
        if (that.timer > 0) {
          that.messageBtn = that.timer + "s后重新获取";
          that.timer--;
        } else {
          that.messageBtn = "发送短信验证码";
          clearInterval(setInterObj);
        }
      }, 1000);
      let params = {};
      params.mobilePhone = that.ruleForm1.username;
      params.templateType = "SMS_201455506";
      let response = that.apiService
        .get("/sinoslog-ops-service/sendMessage/smsCode", { params })
        .then(res => {
          if (res.data.data.msg == "error") {
            that.$message({
              showClose: true,
              customClass: "register-bg",
              message: "获取验证码失败",
              type: "error",
              offset: 300
            });
          }
        });
    },
    //立即登录
    nowLogin() {
      var that = this;
      let data = {};
      data.userDomainCode = "SSLCP";
      data.userAccountName = that.ruleForm1.username;
      data.password = that.ruleForm3.newPasswd;
      let response = that.apiService
        .post("/sinoslog-ops-service/user/login", data)
        .then(res => {
          if (res.data.data.data && res.data.data.msg) {
            that.$cookies.set("username", that.ruleForm1.phone, "7d");
            that.$cookies.set("password", that.ruleForm2.passwd, "7d");
            localStorage.setItem(
              "userInfo",
              JSON.stringify(res.data.data.data)
            ); //用户信息
            that.$router.push({ name: "Home" });
          } else {
            that.$message({
              showClose: true,
              customClass: "register-bg",
              message: res.data.errorMessages[0],
              type: "error",
              offset: 300
            });
          }
        });
    },
    //生成随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    //刷新图片验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    //制作随机码
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    //其它验证方式提交按钮
    submitMailbox() {
      this.$refs.mailForm.validate(valid => {
        if (valid) {
          console.log(this.mailForm);
        } else {
          console.log(555);
          return false;
        }
      });
    },
    //切换验证方式（已换号按钮）
    exchangeMark() {
      this.foMode = 2;
    },
    //切换验证方式（手机验证立即验证按钮）
    cellphoneVerify() {
      this.foMode = 1;
    },
    //切换验证方式（其它验证立即验证按钮）
    cellphoneVerify2() {
      this.foMode = 2;
    },
    //更换其它验证方式（文字按钮）
    cellphoneVerify3() {
      this.foMode = 3;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.message-icon {
  background-image: url("../assets/img/icon-message-unselect.png");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 30px;
}

.message-icon-active {
  background-image: url("../assets/img/icon-message-select.png");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 30px;
}

.set-password {
  background-image: url("../assets/img/icon-password-unselect.png");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 30px;
}

.set-password-active {
  background-image: url("../assets/img/icon-password-select.png");
  background-size: contain;
  background-repeat: no-repeat;
  padding: 30px;
}
.demo-ruleForm3 > .el-form-item {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/ForgetPassword.vue